/**
 * Form interactions
 * 
 * @since 1.0.0
 * @package crunchy
 */

(function($) {
	$(document).ready(function() {

		// init vars
		var formWrap, form, input;

		// get and bind stuff
		resetStates();

		// reset things on submit
		$(document).bind( 'gform_post_render', resetStates );


		/**
		 * Reset form element states
		 */
		function resetStates() {

			// re-bind vars
			formWrap  = $( '.gform_wrapper' );
			form      = $( 'form', formWrap );
			input     = $( 'input, select, textarea', formWrap  );
			dateInput = $( 'input.datepicker', formWrap );

			// bind inputs
			bindInputs();

			// check inputs
			input.each( checkInput );
		}


		/**
		 * Bind input changes
		 */
		function bindInputs() {
			input.on( 'change',   checkInput );
			input.on( 'focus',    focusField );
			input.on( 'focusout', unfocusField );
			dateInput.on( 'focus', focusDatePicker );
			form.submit( doOverlay );
		}



		/**
		 * Check a form input and see if it needs
		 * to be validated / left open
		 * 
		 * @since 1.0.0
		 */
		function checkInput() {

			var $this = $(this);

			// get type
			var inputType = $this.prop( 'type' );

			// bounce if hidden
			if ( inputType == 'hidden' ) {
				return;
			}

			// get parent field
			var field = getField( $this );

			// always apply to file
			if ( inputType == 'file' ) {
				field.addClass( 'filled' );
				return;
			}

			// filled?
			if ( $this.val() ) {
				field.addClass( 'filled' );
			} else {
				field.removeClass( 'filled' );
			}
		}



		/**
		 * Add focus class to the input's field
		 * 
		 * @since 1.0.0
		 */
		function focusField() {
			$( getField( $(this) ) ).addClass( 'focused' );
		}
	


		/**
		 * Remove focus class from the input's field
		 * 
		 * @since 1.0.0
		 */
		function unfocusField() {

			var field = $( getField( $(this) ) );

			// unfocus
			field.removeClass( 'focused' );

			// had error? give them a chance!
			if ( field.hasClass( 'gfield_error' ) ) {
				field.removeClass( 'gfield_error' );
				field.addClass( 'error-resolved' );
			}
		}



		/**
		 * Get an input's parent field
		 * 
		 * @param object  jQuery input object
		 * 
		 * @since 1.0.0
		 */
		function getField( input ) {
			return input.closest( '.gfield' );
		}



		/**
		 * Bind focus event to datepicker
		 * 
		 * @param object  jQuery focus event
		 * 
		 * @since 1.0.0
		 */
		function focusDatePicker( e ) {

			// get date field
			var dateField = getField( $( e.target ) );

			// force focus
			dateField.addClass( 'focused-stay' );

			// remove forced focus on close
			// var datePicker = $( '#ui-datepicker-div' ).datepicker( 'widget' );
			// console.log( datePicker );
			console.log( $( '#ui-datepicker-div').datepicker( 'option', 'onClose') );
			$( '#ui-datepicker-div' ).datepicker( 'option', 'onClose', function() {
			});
		}



		/**
		 * Put an overlay on the form
		 * 
		 * @since 1.0.0
		 */
		function doOverlay() {
			form.addClass( 'ajax-overlay' );
		}

	}); // document.ready
})(jQuery);


// jQuery(document).bind('gform_confirmation_loaded', function(event, formId){
//     console.log( 'ELLO POPPET!' );
// });